/**
 * Homepage slots. These were the built-in defaults of CommunitySection,
 * RecentDealsSection and FAQSection, so any page that reused one of those
 * sections without naming its own slot quietly rendered the homepage's banner.
 * The sections no longer default; the homepage names them here instead.
 */
export const HOMEPAGE_COMMUNITY_SPONSORED_POSITION = '2' as const;
export const HOMEPAGE_RECENT_DEALS_SPONSORED_POSITION = '3' as const;
export const HOMEPAGE_FAQ_SPONSORED_POSITION = '4' as const;

/**
 * Sponsored banner slot for the public `/dispensary` page.
 * Must match the locked position in admin: Pages → Dispensary → Sponsored Banner 1.
 */
export const DISPENSARY_PAGE_SPONSORED_POSITION = 'dispensary-1' as const;
export const DISPENSARY_PAGE_FAQ_SPONSORED_POSITION = 'dispensary-2' as const;

/**
 * Sponsored banner slot for the public `/dispensary/calgary` page.
 * Must match the locked position in admin: Pages → Dispensary Calgary → Sponsored Banner 1.
 */
export const DISPENSARY_CALGARY_PAGE_SPONSORED_POSITION = 'dispensary-calgary-1' as const;
export const DISPENSARY_CALGARY_PAGE_FAQ_SPONSORED_POSITION = 'dispensary-calgary-2' as const;

/**
 * Sponsored banner below the mail-order service cards on `/mail-order-delivery`.
 * Must match admin Pages → Mail order delivery (when configured).
 */
export const MAIL_ORDER_PAGE_SPONSORED_POSITION = 'mail-order-delivery-1' as const;

/**
 * Sponsored banner at the bottom of the “How our cannabis delivery work(s)” block on `/mail-order-delivery`.
 * Admin: Pages → Mail order delivery → Sponsored Banner 2 (mail-order-delivery-2).
 */
export const MAIL_ORDER_HOW_IT_WORKS_SPONSORED_POSITION = 'mail-order-delivery-2' as const;

/**
 * Sponsored banner on event detail pages (`/events/[slug]`).
 * Must match admin: Pages → Event detail → Sponsored Banner.
 */
export const EVENT_DETAIL_PAGE_SPONSORED_POSITION = 'event-detail-1' as const;

/**
 * Sponsored banner on blog post pages (`/blog/[slug]`).
 * Must match admin: Pages → Blog post → Sponsored Banner.
 */
export const BLOG_POST_PAGE_SPONSORED_POSITION = 'blog-post-1' as const;

/**
 * Sponsored banner below the FAQ block on `/reviews`.
 * Must match admin: Pages → Reviews → Sponsored banner (FAQ).
 */
export const REVIEWS_PAGE_FAQ_SPONSORED_POSITION = 'reviews-faq' as const;

/**
 * Below the Calgary community + video block on `/why-dank`.
 * Admin: Pages → Why Dank → Sponsored banner (community).
 */
export const WHY_DANK_COMMUNITY_SPONSORED_POSITION = 'why-dank-1' as const;

/**
 * Below the merch / lifestyle block on `/why-dank`.
 * Admin: Pages → Why Dank → Sponsored banner (merch).
 */
export const WHY_DANK_MERCH_SPONSORED_POSITION = 'why-dank-2' as const;

/**
 * Below the FAQ on `/why-dank`.
 * Admin: Pages → Why Dank → Sponsored banner (FAQ).
 */
export const WHY_DANK_FAQ_SPONSORED_POSITION = 'why-dank-faq' as const;

/**
 * Below the VIP deals cards on `/dank-club`.
 * Admin: Pages → Dank Club → Sponsored banner (deals).
 */
export const DANK_CLUB_DEALS_SPONSORED_POSITION = 'dank-club-1' as const;

/**
 * Below the FAQ on `/dank-club`.
 * Admin: Pages → Dank Club → Sponsored banner (FAQ).
 */
export const DANK_CLUB_FAQ_SPONSORED_POSITION = 'dank-club-faq' as const;
